// const BASE_URL = `${window.location.protocol}//${window.location.hostname}/Project/EmbroideryBazar/backend`;
const BASE_URL = `https://embroiderybazar.in/backend`;
export const API = {
  BASE_URL,
  GET_SETTINGS: `${BASE_URL}/api.php?action=getSettings`,
  GET_DESIGNER_ORDERS: `${BASE_URL}/api.php?action=getDesignerOrders`,
  UPDATE_SETTINGS: `${BASE_URL}/api.php?action=updateSettings`,
  DESIGNER_DASHBOARD: `${BASE_URL}/api.php?action=designer_dashboard`,
  UPDATE_DESIGNER_UPLOAD_DATE:
    BASE_URL + "/api.php?action=update_designer_upload_date",
  DELETE_USER: `${BASE_URL}/api.php?action=delete_user`,
  DOWNLOAD: `${BASE_URL}/payment.php?action=download_file`,
  ADD_HERO_SLIDER: `${BASE_URL}/api.php?action=add_hero_slider`,
  GET_HERO_SLIDER: `${BASE_URL}/api.php?action=get_hero_slider`,
  DELETE_HERO_SLIDER: `${BASE_URL}/api.php?action=delete_hero_slider`,
  REGISTER: `${BASE_URL}/api.php?action=register`,
  LOGIN: `${BASE_URL}/api.php?action=login`,
  LOGOUT: `${BASE_URL}/api.php?action=logout`,
  COUNTS1: `${BASE_URL}/api.php?get_counts`,
  ADMIN_DESIGNER_STATISTICS: `${BASE_URL}/api.php?action=admin_designer_statistics`,
  UPDATE_DESIGN_UPLOAD_STATUS: `${BASE_URL}/api.php?action=update_design_upload_status`,
  GET_WORK_TRANSACTIONS: `${BASE_URL}/payment.php?action=get_work_transactions`,

  ADD_ADS_PLAN: `${BASE_URL}/api.php?action=add_ads_plan`,
  DELETE_ADS_PLAN: `${BASE_URL}/api.php?action=delete_ads_plan`,
  UPDATE_ADS_PLAN: `${BASE_URL}/api.php?action=update_ads_plan`,
  GET_ADS_PLANS: `${BASE_URL}/api.php?action=get_ads_plans`,
  LIST_ALL_DESIGNS: `${BASE_URL}/api.php?action=list_designs`,
  LIST_DESIGNS: `${BASE_URL}/api.php?action=list_designs`,
  ADD_DESIGN: `${BASE_URL}/api.php?action=add_design`,
  DELETE_DESIGN: `${BASE_URL}/api.php?action=delete_design`,
  UPDATE_DESIGN: `${BASE_URL}/api.php?action=update_design`,
  ADD_CONCEPT: `${BASE_URL}/api.php?action=add_concept`,
  CONCEPT_LIST: `${BASE_URL}/api.php?action=list_concepts`,
  DELETE_CONCEPT: `${BASE_URL}/api.php?action=delete_concept`,
  UPDATE_CONCEPT: `${BASE_URL}/api.php?action=update_concept`,

  LIST_DESIGNS_user: `${BASE_URL}/api.php?action=list_designs_limituser`,
  ADD_DESIGN_user: `${BASE_URL}/api.php?action=add_designuser`,
  DELETE_DESIGN_user: `${BASE_URL}/api.php?action=delete_designuser`,
  UPDATE_DESIGN_user: `${BASE_URL}/api.php?action=update_designuser`,
  LIST_ALL_DESIGNS_user: `${BASE_URL}/api.php?action=list_designsuser`,

  ADD_SUPPLIER: `${BASE_URL}/api.php?action=add_supplier`,
  UPDATE_SUPPLIER: `${BASE_URL}/api.php?action=update_supplier`,
  DELETE_SUPPLIER: `${BASE_URL}/api.php?action=delete_supplier`,
  GET_SUPPLIER: `${BASE_URL}/api.php?action=supplier_list`,
  GET_SUPPLIER_USER: `${BASE_URL}/api.php?action=supplier_user`,
  GET_PROFILE: `${BASE_URL}/api.php?action=get_profile`,
  GET_SUPPLIER_STATUS: `${BASE_URL}/api.php?action=supplier_status`,
  CHANGE_SUPPLIER_STATUS: `${BASE_URL}/api.php?action=change_supplier_status`,
  RENEW_SUPPLIER_ADS: `${BASE_URL}/api.php?action=renew_supplier_ads`,

  UPDATE_SPAREPARTS: `${BASE_URL}/api.php?action=update_spareparts`,
  ADD_DESIGNER: `${BASE_URL}/api.php?action=add`,
  LIST_PENDING: `${BASE_URL}/api.php?action=list_all`,
  LIST_ACTIVE_DESIGNERS: `${BASE_URL}/api.php?action=list_active`,
  UPDATE_DESIGNER_STATUS: `${BASE_URL}/api.php?action=update_status`,
  DELETE_DESIGNER: `${BASE_URL}/api.php?action=delete`,
  GET_SINGLE_DESIGNER: `${BASE_URL}/api.php?action=get_single`,
  USER_DESIGNERS: `${BASE_URL}/api.php?action=user_designers`,
  UPDATE_DESIGNERS: `${BASE_URL}/api.php?action=update_profile`,
  RENEW_ADS: `${BASE_URL}/api.php?action=renew_ads`,

  ADD_WORKSPACE: `${BASE_URL}/api.php?action=add_workspace`,
  UPDATE_WORKSPACE: `${BASE_URL}/api.php?action=update_workspace`,
  LIST_PENDING_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Pending`,
  LIST_ACTIVE_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Active`,
  UPDATE_WORKSPACE_STATUS: `${BASE_URL}/api.php?action=workspace_status`,
  DELETE_WORKSPACE: `${BASE_URL}/api.php?action=delete_workspace`,
  LIST_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces`,
  LIST_HIDE_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Hidden`,

  ADD_MACHINE: `${BASE_URL}/api.php?action=add_machine`,
  UPDATE_MACHINE: `${BASE_URL}/api.php?action=update_machine`,
  LIST_MACHINES: `${BASE_URL}/api.php?action=list_machines`,
  LIST_ACTIVE_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Active`,
  LIST_PENDING_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Pending`,
  UPDATE_MACHINE_STATUS: `${BASE_URL}/api.php?action=update_machine_status`,
  DELETE_MACHINE: `${BASE_URL}/api.php?action=delete_machine`,
  LIST_HIDE_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Hide`,
  LIST_USERS: `${BASE_URL}/api.php?action=list`,
  USER_DETAILS: `${BASE_URL}/api.php?action=user_details`,
  BLOCK_USER: `${BASE_URL}/api.php?action=block`,
  UNBLOCK_USER: `${BASE_URL}/api.php?action=unblock`,
  GET_USER: `${BASE_URL}/api.php?action=getuser&id=`,
  PROFILE: `${BASE_URL}/api.php?action=profile`,
  UPDATE_PROFILE: `${BASE_URL}/api.php?action=update`,
  UPDATE_USER_ADMIN: `${BASE_URL}/api.php?action=updatefromadmin`,
  SEND_PASSWORD_RESET_OTP: `${BASE_URL}/api.php?action=send_password_reset_otp`,
  UPDATE_PASSWORD: `${BASE_URL}/api.php?action=update_password`,
  GET_ALL_HIRING: `${BASE_URL}/api.php?action=get_all_hiring`,
  UPDATE_HIRING_STATUS: `${BASE_URL}/api.php?action=update_hiring_status`,
  CHANGE_PASSWORD: `${BASE_URL}/api.php?action=password`,
  FORGOT_PASSWORD: `${BASE_URL}/api.php?action=forgot_password`,
  VERIFY_OTP: `${BASE_URL}/api.php?action=verify_otp`,
  RESET_PASSWORD: `${BASE_URL}/api.php?action=reset_password`,
  ADD_HIRING: `${BASE_URL}/api.php?action=add_hiring`,
  UPDATE_HIRING: `${BASE_URL}/api.php?action=update_hiring`,
  DELETE_HIRING: `${BASE_URL}/api.php?action=delete_hiring`,
  GET_HIRING: `${BASE_URL}/api.php?action=get_hiring`,
  GET_ACTIVE_HIRING: `${BASE_URL}/api.php?action=get_active_hiring`,

  ALL_ORDERS: `${BASE_URL}/api.php?action=all_orders`,
  LIST_USER_ORDERS: `${BASE_URL}/api.php?action=list_user_orders`,
  UPDATE_ORDER_STATUS: `${BASE_URL}/api.php?action=update_order_status`,
  PLACE_ORDER: `${BASE_URL}/api.php?action=place_order`,

  SEARCH: `${BASE_URL}/api.php?action=search`,

  CONTACT: `${BASE_URL}/api.php?action=list_contact`,

  ADMIN_DASHBOARD: `${BASE_URL}/api.php?action=admin_dashboard`,

  USER_DASHBOARD: `${BASE_URL}/api.php?action=user_dashboard`,

  ADD_SUBCATEGORY: `${BASE_URL}/api.php?action=add_subcategory`,

  LIST_SUBCATEGORY: `${BASE_URL}/api.php?action=list_subcategories`,

  UPDATE_SUBCATEGORY: `${BASE_URL}/api.php?action=update_subcategory`,

  DELETE_SUBCATEGORY: `${BASE_URL}/api.php?action=delete_subcategory`,
  COUNT_VISITOR: `${BASE_URL}/api.php?action=COUNT_VISITOR`,
  VISITOR_STATISTICS: `${BASE_URL}/api.php?action=VISITOR_STATISTICS`,

  CREATE_MACHINE_ORDER: `${BASE_URL}/payment.php?action=create_machine_order`,
  VERIFY_MACHINE_PAYMENT: `${BASE_URL}/payment.php?action=verify_machine_payment`,

  CREATE_MACHINE_RENEW_ORDER: `${BASE_URL}/payment.php?action=renew_machine_order`,
  VERIFY_MACHINE_RENEW_PAYMENT: `${BASE_URL}/payment.php?action=verify_machine_ads_payment`,

  CREATE_WORKSPACE_ORDER: `${BASE_URL}/payment.php?action=create_workspace_order`,
  VERIFY_WORKSPACE_PAYMENT: `${BASE_URL}/payment.php?action=verify_workspace_payment`,
  CREATE_WORKSPACE_RENEW_ORDER: `${BASE_URL}/payment.php?action=renew_workspace_order`,
  VERIFY_WORKSPACE_RENEW_PAYMENT: `${BASE_URL}/payment.php?action=verify_workspace_renew_payment`,
  FREE_RENEW_WORKSPACE: `${BASE_URL}/payment.php?action=use_workspace_free_plan`,

  GET_MACHINE_TRANSACTIONS: `${BASE_URL}/api.php?action=get_machine_transactions`,

  GET_WORKSPACE_TRANSACTIONS: `${BASE_URL}/api.php?action=get_workspace_transactions`,
};

export const UPLOADS = {
  SLIDER_IMAGE: `${BASE_URL}/uploads/slider/`,
  DESIGN_IMAGE: `${BASE_URL}/uploads/`,
  DESIGN_IMAGE1: `${BASE_URL}/uploads/Design_seller/`,
  DESIGN_FILE: `${BASE_URL}/uploads/`,
  WORKSPACE_IMAGE: `${BASE_URL}/uploads/`,
  WORK_IMAGE: `${BASE_URL}/uploads/work`,
  MACHINE_IMAGE: `${BASE_URL}/uploads/machine/`,

  DESIGNER_IMAGE: `${BASE_URL}/uploads/Designers/`,
  PROFILE_IMAGE: `${BASE_URL}/uploads/profile/`,
};
